var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTypeAddressPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7521 0.999512H4.93256C2.76038 0.999512 0.999512 2.76044 0.999512 4.93262V21.7521C0.999512 23.9243 2.76038 25.6852 4.93256 25.6852H21.7521C23.9243 25.6852 25.6852 23.9243 25.6852 21.7521V4.93262C25.6852 2.76044 23.9243 0.999512 21.7521 0.999512Z",
    stroke: "black",
    strokeWidth: 1.99937,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51817 5.4044C11.6303 3.29228 15.0546 3.29228 17.1667 5.4044C19.2788 7.51651 19.2788 10.941 17.1667 13.0531L13.3424 16.8774L9.51817 13.0531C7.40605 10.941 7.40605 7.51651 9.51817 5.4044V5.4044Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3424 11.2066C14.4348 11.2066 15.3205 10.321 15.3205 9.22855C15.3205 8.13609 14.4348 7.25049 13.3424 7.25049C12.2499 7.25049 11.3643 8.13609 11.3643 9.22855C11.3643 10.321 12.2499 11.2066 13.3424 11.2066Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89062 23.3287V19.2393H10.504C10.8142 19.2393 11.0785 19.2985 11.2968 19.4171C11.5151 19.5343 11.6815 19.6974 11.796 19.9063C11.9119 20.114 11.9697 20.3536 11.9697 20.6251C11.9697 20.8967 11.9112 21.1363 11.794 21.344C11.6768 21.5503 11.507 21.712 11.2848 21.8292C11.0638 21.945 10.7962 22.003 10.4821 22.003H9.75525V23.3288L8.89062 23.3287ZM9.75525 21.31H10.3423C10.5899 21.31 10.7743 21.2467 10.8954 21.1203C11.018 20.9925 11.0793 20.8275 11.0793 20.6251C11.0793 20.4215 11.018 20.2577 10.8954 20.1339C10.7744 20.0088 10.5887 19.9463 10.3383 19.9463H9.75525V21.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2947 21.2842C16.2947 21.7301 16.2102 22.1095 16.0411 22.4223C15.8734 22.7352 15.645 22.9741 15.3562 23.1392C15.0673 23.3029 14.7418 23.3847 14.3797 23.3847C14.0163 23.3847 13.6902 23.3022 13.4013 23.1372C13.1124 22.9722 12.8842 22.7332 12.7165 22.4203C12.5487 22.1062 12.4648 21.7275 12.4648 21.2842C12.4648 20.8382 12.5487 20.4588 12.7165 20.146C12.8842 19.8332 13.1124 19.5949 13.4013 19.4312C13.6902 19.2661 14.0163 19.1836 14.3797 19.1836C14.7418 19.1836 15.0673 19.2661 15.3562 19.4312C15.645 19.5949 15.8734 19.8331 16.0411 20.146C16.2102 20.4588 16.2947 20.8382 16.2947 21.2842V21.2842ZM15.4181 21.2842C15.4181 20.8502 15.3236 20.5194 15.1345 20.2918C14.9455 20.0628 14.6939 19.9483 14.3797 19.9483C14.0656 19.9483 13.814 20.0628 13.625 20.2918C13.4359 20.5194 13.3413 20.8502 13.3413 21.2842C13.3413 21.7168 13.4359 22.0476 13.625 22.2766C13.814 22.5055 14.0656 22.62 14.3797 22.62C14.6939 22.62 14.9455 22.5055 15.1345 22.2766C15.3236 22.0476 15.4181 21.7168 15.4181 21.2842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7942 19.2393V23.3287H16.9297V19.2393H17.7942Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.685,
    height: 26.685,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeAddressPoi);
export default __webpack_public_path__ + "static/media/icon_type_address_poi.f68f31d57171cfc191884633f8aa9044.svg";
export { ForwardRef as ReactComponent };